import { render, staticRenderFns } from "./agentRewardAccount.vue?vue&type=template&id=5af04b60&scoped=true"
import script from "./agentRewardAccount.vue?vue&type=script&lang=js"
export * from "./agentRewardAccount.vue?vue&type=script&lang=js"
import style0 from "./agentRewardAccount.vue?vue&type=style&index=0&id=5af04b60&prod&lang=scss"
import style1 from "./agentRewardAccount.vue?vue&type=style&index=1&id=5af04b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af04b60",
  null
  
)

export default component.exports